// Service links hold either a bare YouTube video id or any of the
// share/watch/embed URL forms, so normalise to the video id.
export const getYoutubeId = link => {
  if (typeof link !== "string" || !link.trim()) {
    return null;
  }

  if (/^[\w-]{11}$/.test(link.trim())) {
    return link.trim();
  }

  const patterns = [
    /youtu\.be\/([\w-]{11})/,
    /[?&]v=([\w-]{11})/,
    /\/embed\/([\w-]{11})/,
    /\/shorts\/([\w-]{11})/
  ];

  for (const pattern of patterns) {
    const match = link.match(pattern);
    if (match) {
      return match[1];
    }
  }

  return null;
};

export const getEmbedUrl = link => {
  const videoId = getYoutubeId(link);

  return videoId
    ? `https://www.youtube.com/embed/${videoId}?controls=1&fs=1&cc_load_policy=1&enablejsapi=1&origin=${window.location.origin}`
    : null;
};

export const getThumbnailUrl = link => {
  const id = getYoutubeId(link);

  return id ? `https://img.youtube.com/vi/${id}/hqdefault.jpg` : null;
};
